export default {
  dark: '#333',
  primaryPurple: '#312e49',
  red: '#cf0e18',
  teal: '#26b4b0',
  black: '#000',
  white: '#fff',
  violet: '#bfa3ff',
  green: '#3bdbb0',
}
